import Collapse from '@mui/material/Collapse';
import Alert from '@mui/material/Alert';
import { useSettings } from '../context/SettingsContext';

/**
 * Shown app-wide whenever a request 401s. The access key is deployment configuration (see
 * api/client.js), so there is nowhere for the user to go and fix it themselves -- the banner says
 * who can.
 */
export default function AuthBanner() {
  const { authBanner, clearAuthBanner } = useSettings();

  return (
    <Collapse in={Boolean(authBanner)} sx={{ mb: authBanner ? 2 : 0 }}>
      <Alert
        severity="error"
        onClose={clearAuthBanner}
      >
        {authBanner}
      </Alert>
    </Collapse>
  );
}
